import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=f55b40b8&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f55b40b8')) {
      api.createRecord('f55b40b8', component.options)
    } else {
      api.reload('f55b40b8', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=f55b40b8&", function () {
      api.rerender('f55b40b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ClVeeerS0W6F/JS/comp/FavElement.vue"
export default component.exports